import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Frame } from 'app/models/Frame';
import { MapifyPricePipe } from 'app/pipes/mapify-price.pipe';
import { SettingsService } from 'app/services/settings.service';
import { Print } from '../../models/Print';

@Component({
  selector: 'mpf-map-config-frame',
  templateUrl: './map-config-frame.component.html',
  styleUrls: ['./map-config-frame.component.scss']
})
export class MapConfigFrameComponent {
  private _print: Print;

  @Input()
  set print(print: Print) {
    this._print = print;

    const noFrame = {
      id: 'no-frame',
      name: {
        en: 'Unframed',
        de: 'Ohne Rahmen'
      }
    };

    this.frames = [noFrame].concat(print.frames);
    this.selectedFrame = noFrame.id;
  }

  get print() {
    return this._print;
  }

  @Output() frameChange = new EventEmitter<string>();

  selectedFrame: string;
  frames: Frame[];

  constructor(private mapifyPricePipe: MapifyPricePipe, private settingsService: SettingsService) {}

  frameChanged(evt: any) {
    const frameId = evt.value;
    this.frameChange.emit(frameId);
  }

  getFramePrice(frame: Frame): string {
    return frame.id === 'no-frame' ? '' : `+ ${this.mapifyPricePipe.transform([frame.id])}`;
  }

  getFrameName(frame: Frame): string {
    return frame.name[this.settingsService.getLanguage()];
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/map-config-frame/map-config-frame.component.ts